import React from 'react';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, TextControl, Button, Flex } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

interface CalculatorInspectorProps {
  localCalcId: string;
  currentCalcId: string;
  onCalcIdChange: (newValue: string) => void;
  onEditClick: () => void;
  onEmbedClick: () => void;
  onSelectCalculatorClick: () => void;
  errorMessage?: string;
}

export default function CalculatorInspector({
  localCalcId,
  currentCalcId,
  onCalcIdChange,
  onEditClick,
  onEmbedClick,
  onSelectCalculatorClick,
  errorMessage,
}: CalculatorInspectorProps): JSX.Element {
  return (
    <InspectorControls>
      <PanelBody
        title={__('Calculator Settings', 'convertcalculator')}
        initialOpen={true}
      >
        <Flex align="center" className="calc-inspector-flex">
          <TextControl
            label={__('Calculator ID', 'convertcalculator')}
            value={localCalcId}
            onChange={onCalcIdChange}
            maxLength={17}
            className="calc-id-input"
          />
          <Button
            variant="primary"
            onClick={onEmbedClick}
            disabled={!!errorMessage || localCalcId === currentCalcId}
            className="embed-button"
          >
            {__('Update Embed', 'convertcalculator')}
          </Button>
        </Flex>

        <Flex className="calc-inspector-buttons">
          <Button variant="secondary" onClick={onEditClick} disabled={!!errorMessage}>
            {__('Edit', 'convertcalculator')}
          </Button>
          <Button variant="primary" onClick={onSelectCalculatorClick}>
            {__('Select Calculator', 'convertcalculator')}
          </Button>
        </Flex>

        <div className="calc-error-container">
          {errorMessage && <p className="calc-error-message">{errorMessage}</p>}
        </div>
      </PanelBody>
    </InspectorControls>
  );
}
